import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ProfessionalAccount.css";

import { FaPlus } from "react-icons/fa6";
import ProfessionalForm from "./ProfessionalForm";
import {
  myServices,
  setMyServiceData,
} from "../../../../Redux/Slices/Pages/services/servicesSlice";

import WorkerProfileCard from "../../../../Components/Card/WorkerCard/Workercard";

const ProfessionalAccount = () => {
  const [showProfileform, setShowProfileform] = useState(false);
  const dispatch = useDispatch();
  const myServiceInfo = useSelector((state) => state.services.myServiceData);
  console.log(myServiceInfo.length, "service info");

  useEffect(() => {
    dispatch(myServices());
    return () => {
      dispatch(setMyServiceData([]));
    };
  }, []);

  const handleprofile = () => {
    setShowProfileform(true);
  };

  return (
    <>
      <div className="head-section">
        <h3 className="text-2xl p-6 font-semibold">My Profession</h3> 

        
      </div>

      {myServiceInfo.length >0 ? (
        <WorkerProfileCard />
      ) : showProfileform ? (
        <ProfessionalForm />
      ) : (
        <div className="account-section w-full bg-white p-6">
          <div className=" flex flex-col  justify-center items-center w-1/2 mx-auto h-1/2">
            <h2 className="p-5 font-medium">
              You have not yet added any professional service{" "}
            </h2>

            <FaPlus />
            <h1 className="p-4 ">Please add new professional service</h1>
            <button
              className="prof-button py-2 px-3 text-white "
              onClick={handleprofile}
            >
              Add Your Profession
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfessionalAccount;
